// Favre — wjazdy sekcji przy przewijaniu: SAMO PRZENIKANIE (opacity) na wszystko (decyzja usera 2026-10-22).
// IntersectionObserver + przejście CSS (assets/favre-wjazd.css). Ruch (linie spod maski, kafle z dołu, skala bloków
// z wariantu eloqwnt z 2026-10-21) usunięty. Teksty, karty i duże bloki pojawiają się każdy osobno, gdy wejdą na ekran;
// wstęp (akapit) chwilę po nagłówku. Pierwszy ekran NIE jest animowany. Po przenikaniu zdejmujemy atrybuty
// (hover kart działa jak wcześniej). Bez JS / „ograniczanie ruchu” — wszystko widoczne. ?wjazd=brak wyłącza na czas wizyty.
(() => {
  if (window.__favreWjazd) return;
  window.__favreWjazd = true;
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ?wjazd=brak — wyłączenie na czas wizyty (do porównań / diagnozy)
  try {
    const q = new URLSearchParams(location.search).get('wjazd');
    if (q) sessionStorage.setItem('favre-wjazd', q);
    if (sessionStorage.getItem('favre-wjazd') === 'brak') return;
  } catch (e) {}
  document.documentElement.classList.add('fw-on');

  // teksty (nagłówki, nadpisy, wstępy)
  const TEKST = [
    '.fl__heading', '.fs__heading', '.fb__heading', '.fc__title', '.fs-title', '.fst__name', '.fz__h2',
    '.filmy-ugc__nadpis > span', '.filmy-ugc__tytul', '.filmy-ugc__tekst p',
    '.spolecznosc__nadpis > span', '.spolecznosc__tytul',
    '.fga__eyebrow > span', '.fga__title', '.fga__text p',
    '.fs-eyebrow', '.fs-intro p', '.ffoot__naglowek',
  ].join(',');
  // karty: każda osobno, gdy wejdzie na ekran
  const KARTY = [
    '.fl__grid > li', '.filmy-ugc__lista > li', '.fc__grid > li', '.fs__grid > *', '.fgal__grid > li',
    '.fst__grid > *', '.fb__list > *', '.fz__how li',
  ].join(',');
  // duże bloki: jedno przenikanie na całość
  const DUZE = ['.fga__stage', '.spolecznosc__markiza', '.fz__tablewrap', '.fb__sum', '.fb__fotos'].join(',');

  const ponizejEkranu = (el) => el.getBoundingClientRect().top > innerHeight - 10;

  /* ---------- odsłonięcie i sprzątanie ---------- */
  const pokaz = (el, opoznienie) => {
    el.style.setProperty('--fw-d', `${opoznienie}ms`);
    el.classList.add('fw-in');
    setTimeout(() => {
      el.classList.remove('fw-in');
      el.removeAttribute('data-fw');
      el.style.removeProperty('--fw-d');
    }, 900 + opoznienie + 100);
  };

  const io = new IntersectionObserver((wpisy) => {
    // każdy element ma własny wyzwalacz (bez kaskady kart); wstęp chwilę po nagłówku
    wpisy.forEach((w) => {
      if (!w.isIntersecting) return;
      io.unobserve(w.target);
      const el = w.target;
      pokaz(el, el.dataset.fw === 'tekst' && el.__fwPo ? 100 : 0);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  const przygotuj = (scope) => {
    scope.querySelectorAll(TEKST).forEach((el) => {
      if (el.dataset.fw || el.closest('[data-fp]') || !ponizejEkranu(el) || !el.textContent.trim()) return;
      el.dataset.fw = 'tekst';
      if (el.matches('p') || el.matches('.fs-intro p')) el.__fwPo = true;
      io.observe(el);
    });
    scope.querySelectorAll(KARTY).forEach((el) => {
      if (el.dataset.fw || el.closest('[data-fp]') || !ponizejEkranu(el)) return;
      el.dataset.fw = 'karta';
      io.observe(el);
    });
    scope.querySelectorAll(DUZE).forEach((el) => {
      if (el.dataset.fw || !ponizejEkranu(el)) return;
      el.dataset.fw = 'duze';
      io.observe(el);
    });
  };

  const start = () => przygotuj(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  // edytor motywu: sekcja dodana / przeładowana
  document.addEventListener('shopify:section:load', (e) => przygotuj(e.target));
})();
